import React, { PropsWithChildren } from 'react';
import { Formik, Form, FormikConfig, FormikProps } from 'formik';
import noop from 'lodash/noop';

// components
import FormAccordionHelper, { SectionType } from 'pages/MerchantPages/Assets/components/AccordionHelper';

// own components
import FormikEffect from './FormikEffect';

interface OwnProps<Values> {
  closePanel?: () => void;
  formId?: string;
  onChange?: (values: Values) => void;
  onStatusChange?: (formikProps: FormikProps<Values>) => void;
}

type Props<Values, P = {}> = PropsWithChildren<OwnProps<Values> & P> & FormikConfig<Values>;

const FormikWrapper = <Values, P = {}>({
  initialValues,
  onSubmit,
  closePanel = () => null,
  formId = 'asset-content',
  onChange,
  onStatusChange,
  children,
  ...rest
}: Props<Values, P>) => (
  <Formik<Values> initialValues={initialValues} onSubmit={onSubmit} {...rest}>
    {() => (
      <Form id={formId}>
        <FormikEffect
          onChange={onChange ?? noop}
          onStatusChange={onStatusChange ?? noop}
          validateOnMount={rest.validateOnMount}
        />
        <FormAccordionHelper
          initialValues={initialValues}
          index={SectionType.Content}
          closePanel={closePanel}
          disableFormikEffect
        />
        {children}
      </Form>
    )}
  </Formik>
);

export default FormikWrapper;
